import Vue from "vue";

export default {
    login(credentials) {
        return Vue.http
            .post("api/v1/login", credentials)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    refresh(refresh_token) {
        return Vue.http
            .post("api/v1/refresh", {refresh_token})
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    userinfo(lang) {
        return Vue.http
            .get("api/v1/userinfo?language=" + lang +'&withStatus=true')
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    points(lang) {
        return Vue.http
            .get("api/v1/points?transactions=1&lang=" + lang)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    invites() {
        return Vue.http
            .get("api/v1/invites")
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    projects() {
        return Vue.http
            .get("api/v1/projects?withProgress=true")
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    },
    carts(lang) {
        return Vue.http
            .get("api/v1/carts?language=" + lang)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    }
};
